// extracted by mini-css-extract-plugin
export default {"Finale":"Finale_Finale__Nf-hU","secondeContainer":"Finale_secondeContainer__nL4TU","Img":"Finale_Img__ZeGzi","WarningMessage":"Finale_WarningMessage__VPzz+"};